import Axios from 'axios';

export const URL_BASE_API = 'https://tunel.equinsaparking.com/vweqp/RestApi';

export let instanciaAxios = Axios.create({
  baseURL: URL_BASE_API,//(process.env.NODE_ENV !== 'production') ? URL_BASE_DEV_API : URL_BASE_PROD_API,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {

  establecerAccessToken(access_token) {
    instanciaAxios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
  },

  eliminarAccessToken() {
    delete instanciaAxios.defaults.headers.common['Authorization']
  },

  async iniciarSesion(email, password) {
    let peticion = {}
    peticion.correoElectronico = email
    peticion.contrasena = password
    return await instanciaAxios.post('/sesion/iniciar', peticion)
  },

  async cerrarSesion() {
    return await instanciaAxios.post('/sesion/cerrar')
  },

  async recuperarContrasena(email, logo) {
    let peticion = {
      correoElectronico: email,
      logotipo: logo
    }
    return await instanciaAxios.post('/recuperar_contrasena', peticion)
  },

  restablecerContrasena (tokenSeguridad, nuevaContrasena) {
    let peticion = {
      tokenSeguridad: tokenSeguridad,
      nuevaContrasena: nuevaContrasena
    };
    return instanciaAxios.post ('/restablecer_contrasena', peticion)
  },

  async comprobarLicencias () {
    return await instanciaAxios.get ('/base_datos/checkLicencias', null)
  },



  //------------------------
  obtenerRegistrosTablaVista (tablaVista, parametros) {
    return instanciaAxios.get (`/base_datos/${tablaVista}`, { params: parametros })
  },
  anadirRegistroTablaVista (tablaVista, registro) {
    return instanciaAxios.post (`/base_datos/${tablaVista}`, registro)
  },
  modificarRegistroTablaVista (tablaVista, registro, claveRegistro) {
    return instanciaAxios.put (`/base_datos/${tablaVista}`, registro, { params: claveRegistro })
  },
  eliminarRegistroTablaVista (tablaVista, claveRegistro) {
    return instanciaAxios.delete (`/base_datos/${tablaVista}`, { params: claveRegistro })
  },
  loteCambiosRegistrosTablaVista (tablaVista, registros, claveRegistro) {
    return instanciaAxios.patch (`/base_datos/${tablaVista}`, registros, { params: claveRegistro })
  },

  obtenerEmpresasInquilinas (parametros) {
    return instanciaAxios.post ('/base_datos/obtenerEmpresasInquilinas',  parametros);
  },

  obtenerResumen () {
    return instanciaAxios.get (`/remsumen`)
  },
  obtenerEntidades (parametros) {
    return instanciaAxios.get (`/entidades`, { params: parametros })
  },

}
